<template>
    <div>


        <v-speed-dial
                v-model="fab"
                bottom
                left
                fixed
                @click.stop=""
                direction="top"
                :transition="transition"
        >
            <template v-slot:activator>
                <v-btn
                        v-model="fab"
                        color="primary"
                        dark
                        fab
                >
                    <v-icon v-if="fab">fas fa-times</v-icon>
                    <v-icon v-else>fas fa-ambulance</v-icon>
                </v-btn>
            </template>
            <v-btn
                    fab
                    light
                    small
                    :color="'#ffd632'"
                    @click="showOpenPotentials"
            >
                <v-icon>far fa-smile-wink</v-icon>
                <span class="buttonText">משעמם לי</span>
            </v-btn>
        </v-speed-dial>
        <v-dialog
                scrollable
                persistent
                v-model="addPotentialsModal"
                max-width="700"
        >
            <v-card>
                <v-overlay :value="overlay" v-if="overlay" class="overlayLoader">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-card-title class="headline text-center">הוספת נקודות למשלוח</v-card-title>
                <v-card-text>
                    סמן ב-וי את המשלוחים שתרצה להוסיף למסלול
                </v-card-text>
                <v-card-text>
                    <v-data-table
                            dir="rtl"
                            v-model="selected"
                            :mobile-breakpoint="0"
                            :no-data-text="'לא קיימים משלוחים נוספים'"
                            :single-expand="true"
                            :headers="headers"
                            :expanded.sync="expanded"
                            :items="potentials"
                            hide-default-footer
                            item-key="id"
                            show-select
                            class="elevation-1"
                            @click:row="clicked"
                    >

                        <template v-slot:item.name="{item}">
                            <span>{{item.Shipping_Street}} {{item.House_Number}}, {{item.Shipping_City}}</span>
                        </template>
                        <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="pa-0">
                                <v-card>
                                    <v-card-text class="d-flex justify-space-between py-2">
                                        <span class="cardTitle">שם</span>
                                        <span class="cardText">{{item.Contact_Name.name}}</span>
                                    </v-card-text>
                                    <v-card-text class="d-flex justify-space-between py-2">
                                        <span class="cardTitle">טלפון</span>
                                        <span class="cardText">{{item.Receiver_Phone}}</span>
                                    </v-card-text>
                                    <v-card-text class="d-flex justify-space-between py-2">
                                        <span class="cardTitle">עיר</span>
                                        <span class="cardText">{{item.Shipping_City}}</span>
                                    </v-card-text>
                                    <v-card-text class="d-flex justify-space-between py-2">
                                        <span class="cardTitle">רחוב</span>
                                        <span class="cardText">{{item.Shipping_Street}}</span>
                                    </v-card-text>
                                    <v-card-text class="d-flex justify-space-between py-2">
                                        <span class="cardTitle">מספר בית</span>
                                        <span class="cardText">{{item.House_Number}}</span>
                                    </v-card-text>
                                    <v-card-text class="d-flex justify-space-between py-2">
                                        <span class="cardTitle">הערות</span>
                                        <span class="cardText">{{item.Notes1}}</span>
                                    </v-card-text>
                                    <v-card-text class="d-flex justify-space-between py-2">
                                        <span class="productsTitle">מוצרים</span>
                                    </v-card-text>
                                    <v-card-text class="d-flex justify-space-between py-2"
                                                 v-for="product in item.products"
                                                 :key="product + '_product'"
                                                 v-if="product.product.id !== '1194472000040866020'">
                                        <span class="cardTitle">{{product.product.name}}</span>
                                        <span class="cardText">{{product.quantity}}</span>
                                    </v-card-text>

                                </v-card>
                            </td>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                    color="primary darken-1"
                                    x-large
                                    block
                                    elevation="0"
                                    :disabled="selected.length < 1"
                                    class="mb-5"
                                    @click="addPotentialsToMap"
                            >
                                הוספה
                            </v-btn>
                            <v-btn
                                    color="error darken-1"
                                    outlined
                                    elevation="0"
                                    block
                                    @click="addPotentialsModal = false"
                            >
                                ביטול
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {HTTP} from '../http/http-common.js';

    export default {
        name: "vAddPotentials",
        data: () => ({
            direction: 'top',
            fab: false,
            addPotentialsModal: false,
            bottom: true,
            left: false,
            overlay: false,
            expanded: [],
            currentLat: 0,
            currentLon: 0,
            transition: 'slide-y-reverse-transition',
            selected: [],
            headers: [
                {text: 'כתובת', align: 'start', value: 'name', sortable: false,},
                {text: 'מרחק (בק"מ)', align: 'left', value: 'distance', sortable: true,},
            ],
            potentials: []
        }),
        beforeMount() {
            this.getAvailablePotentials()
            let self = this;
            navigator.geolocation.getCurrentPosition(function (response) {
                self.currentLat = response.coords.latitude;
                self.currentLon = response.coords.longitude;
            });

        },
        methods: {
            calculateDistance: function calculateDistance(lat1, lng1) {
                let lat2 = this.currentLat;
                let lng2 = this.currentLon;
                let R = 6371; // Radius of the earth in km
                let dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
                let dLon = this.deg2rad(lng2 - lng1);
                let a =
                    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                    Math.sin(dLon / 2) * Math.sin(dLon / 2);
                let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                let d = R * c; // Distance in km
                return parseFloat((d).toFixed(2));
            },
            deg2rad: function deg2rad(deg) {
                return deg * (Math.PI / 180)
            },
            showLoader: function () {
                this.overlay = true;
            },
            hideLoader: function () {
                this.overlay = false;
            },
            showOpenPotentials: function showOpenPotentials() {
                this.addPotentialsModal = true
            },
            addPotentialsToMap: function addPotentialsToMap() {
                let counter = 0;
                let self = this;
                self.showLoader()

                this.selected.forEach(function (potential) {
                    let data = {
                        dealID: potential.id,
                        messenger: window.localStorage.getItem('Name')
                    }
                    HTTP.post('/set_deal_date/' + potential.id, data).then(function (resp) {
                        counter++
                        if (counter === self.selected.length) {
                            // window.location.reload(true)
                        }
                    })
                })

                self.hideLoader()
            },
            clicked(value) {
                let self = this;
                let allreadyChecked = this.expanded.filter(potential => potential.id === value.id)
                if(allreadyChecked.length) {
                    self.expanded = [];
                } else {
                    self.showLoader()
                    HTTP.get('getProducts/' + value.id).then(function (resp) {
                        self.expanded = [];
                        self.expanded.push(value)
                        value.products = resp;
                        self.hideLoader()
                    })
                }

            },
            getAvailablePotentials: function getAvailablePotentials() {
                let self = this;
                let counter = 0;
                self.showLoader()
                HTTP.get('deals/available').then(function (resp) {
                    if (resp && Object.keys(resp).length) {
                        resp.forEach(function (potential) {
                            resp[counter].distance = self.calculateDistance(potential.Latitude, potential.Longitude);
                            counter++
                        })
                        let results = resp.sort(function (a, b) {
                            var keyA = new Date(a.distance),
                                keyB = new Date(b.distance);
                            // Compare the 2 dates
                            if (keyA < keyB) return -1;
                            if (keyA > keyB) return 1;
                            return 0;
                        })
                        self.potentials = results;
                        self.hideLoader()
                    }
                }).catch(function(){
                    self.hideLoader()
                })
                self.hideLoader()
            }
        }
    }
</script>

<style scoped lang="scss">
    .buttonText {
        position: absolute;
        right: -90px;
        color: black;
        font-size: 16px;
        font-weight: bold;
    }

    span.cardTitle {
        font-weight: bold;
    }

    span.cardText {
        text-align: left;
    }

    span.productsTitle {
        display: block;
        text-align: center;
        width: 100%;
        font-size: 16px;
        font-weight: bold;
    }

    .v-overlay.overlayLoader.theme--dark {
        z-index: 20 !important;
    }
</style>
